module.exports = __webpack_public_path__ + "img/antifa_game_jam.413df8af.png";